import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const SearchDescriptionContainer = styled.div<React.CSSProperties>`
  background: #0f0f0f;
  height: ${360 * Screen.widthRatio}px;
  left: ${310 * Screen.widthRatio}px;
  padding: ${25 * Screen.widthRatio}px ${66 * Screen.widthRatio}px 0 0;
  position: fixed;
  pointer-events: none;
  top: ${-65 * Screen.widthRatio}px;
  width: ${1360 * Screen.widthRatio}px;
  z-index: 1;
`;

export default SearchDescriptionContainer;
